import * as React from 'react';
import { TerminalCredential } from 'services/clients/credentials';

interface Props {
  status: TerminalCredential['status'];
}

export const GenericStatus: React.FC<Props> = (props) => {
  const { status } = props;

  let color = 'bg-red-900';
  let label = 'Invalid';
  let invalid = true;
  switch (status) {
    case 'valid':
    case 'restricted':
      color = 'bg-green-600';
      label = 'Connected';
      invalid = false;
      break;
    case 'not_verified':
      color = 'bg-orange-400';
      label = 'Pending';
      invalid = false;
      break;
    case 'failed':
    case 'expired':
      label = 'Login Error';
      break;
    case 'frozen':
    case 'invalid':
    case 'missing':
    default:
      break;
  }

  return (
    <div
      className={`rounded px-2 py-1 flex items-center space-x-4 ${
        invalid ? 'bg-red-50 text-red-900' : ''
      }`}
    >
      <div className={`w-2 h-2 rounded-full ${color}`} />
      <h4>{label}</h4>
    </div>
  );
};
